import React from 'react';
import { useSpin } from '../../context/SpinContext';
import DropZone from './DropZone';
import { ToggleGroup, ToggleGroupItem } from '../ui/toggle-group';
import { Input } from '../ui/input';

export default function BackgroundControls() {
  const { background, updateBackground, uploadBackgroundImage, clearBackgroundImage, errors } = useSpin();

  return (
    <div className="space-y-4">
      <ToggleGroup
        type="single"
        value={background.type}
        onValueChange={(v) => v && updateBackground({ type: v })}
        className="grid grid-cols-2 gap-2 w-full"
      >
        <ToggleGroupItem value="color" className="border border-neutral-200 rounded-lg data-[state=on]:bg-orange-50 data-[state=on]:border-orange-300 data-[state=on]:text-orange-700">Color</ToggleGroupItem>
        <ToggleGroupItem value="image" className="border border-neutral-200 rounded-lg data-[state=on]:bg-orange-50 data-[state=on]:border-orange-300 data-[state=on]:text-orange-700">Image</ToggleGroupItem>
      </ToggleGroup>

      {background.type === 'color' ? (
        <div className="space-y-3">
          {background.dominantColors.length > 0 && (
            <div>
              <label className="block text-xs font-medium text-neutral-600 mb-2">Suggested from your disc art</label>
              <div className="flex gap-2">
                {background.dominantColors.map((hex, i) => (
                  <button
                    key={`${hex}-${i}`}
                    type="button"
                    onClick={() => updateBackground({ color: hex })}
                    style={{ backgroundColor: hex }}
                    title={hex}
                    className={`w-9 h-9 rounded-full border-2 transition-transform hover:scale-110 ${background.color === hex ? 'border-orange-500' : 'border-white shadow-sm'}`}
                  />
                ))}
              </div>
            </div>
          )}
          <div>
            <label className="block text-xs font-medium text-neutral-600 mb-1.5">Custom color</label>
            <div className="flex items-center gap-2">
              <input
                type="color"
                value={background.color}
                onChange={(e) => updateBackground({ color: e.target.value })}
                className="w-9 h-9 rounded-lg border border-neutral-200 cursor-pointer p-0"
              />
              <Input
                value={background.color}
                onChange={(e) => updateBackground({ color: e.target.value })}
                className="h-9 text-sm font-mono"
              />
            </div>
          </div>
        </div>
      ) : (
        <DropZone
          accept="image/*"
          hint="Will be cropped to cover the full frame"
          onFile={uploadBackgroundImage}
          previewSrc={background.imageUrl}
          fileName={background.imageUrl ? 'Background image' : null}
          onClear={clearBackgroundImage}
          error={errors.background}
        />
      )}
    </div>
  );
}
